<app-split-pane
  storageKey="split.testing"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.testing.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="testingSuggestions" [context]="testingContext" placeholder="Ask about tests or run suites..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="testing.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.testing.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Testing</h2>
            <p class="text-muted mb-3">
              Validate release readiness with clear delivery-focused testing criteria.
            </p>
            <h3 class="h5 mb-3">Delivery Readiness Inputs</h3>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Release type</label>
                <select class="form-select" [(ngModel)]="deliveryTestingDraft.releaseType">
                  <option value="">Select release type...</option>
                  @for (option of releaseTypeOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Environment</label>
                <select class="form-select" [(ngModel)]="deliveryTestingDraft.environment">
                  <option value="">Select environment...</option>
                  @for (option of environmentOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-12">
                <label class="form-label">Test focus areas</label>
                <textarea
                  class="form-control"
                  rows="3"
                  [(ngModel)]="deliveryTestingDraft.testFocus"
                  placeholder="Critical flows, rollback checks, and integration hotspots..."
                ></textarea>
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="checkingReadiness" (click)="runDeliveryReadinessCheck()">
                @if (checkingReadiness) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Checking...
                } @else {
                  Run Delivery Readiness Check
                }
              </button>
            </div>
            @if (testingError) {
              <div class="alert alert-danger mt-3 mb-0">{{ testingError }}</div>
            }
            @if (testingSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ testingSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Delivery Test Summary</h3>
            @if (!hasCheckedReadiness) {
              <div class="small text-muted">No readiness check yet. Run the check to generate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Release type</div>
                  <div class="summary-value">{{ deliveryTestingDraft.releaseType }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Environment</div>
                  <div class="summary-value">{{ deliveryTestingDraft.environment }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Focus areas</div>
                  <div class="summary-value">{{ deliveryTestingDraft.testFocus.trim() || 'No focus areas provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="testing.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
